(function() {
  /** @type {WeakMap<HTMLElement, any>} */
  const initializedCarousels = new WeakMap();
  /** @type {WeakMap<HTMLElement, ReturnType<typeof setInterval> | undefined>} */
  const autoplayIntervals = new WeakMap();

  function cleanupCarousel(carouselElement) {
    const interval = autoplayIntervals.get(carouselElement);
    if (interval) {
      clearInterval(interval);
      autoplayIntervals.delete(carouselElement);
    }
  }

  function initCarousel(carouselElement) {
    if (!carouselElement) return;
    
    // Clean up if already initialized
    if (initializedCarousels.has(carouselElement)) {
      cleanupCarousel(carouselElement);
      initializedCarousels.delete(carouselElement);
    }

    if (typeof EmblaCarousel === 'undefined') {
      setTimeout(() => initCarousel(carouselElement), 100);
      return;
    }

    const embla = EmblaCarousel(carouselElement, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
      slidesToScroll: 1,
      dragFree: false
    });

    initializedCarousels.set(carouselElement, embla);

    const prevButton = carouselElement.closest('.nf-text-slider')?.querySelector('.nf-text-slider__button--prev');
    const nextButton = carouselElement.closest('.nf-text-slider')?.querySelector('.nf-text-slider__button--next');
    const dotsContainer = carouselElement.closest('.nf-text-slider')?.querySelector('.nf-text-slider__dots');
    const slides = carouselElement.querySelectorAll('.nf-text-slider__slide');

    const setupDots = () => {
      if (!dotsContainer) return;
      
      dotsContainer.innerHTML = '';
      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.className = 'nf-text-slider__dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => embla.scrollTo(index));
        dotsContainer.appendChild(dot);
      });
    };

    const updateDots = () => {
      const selectedIndex = embla.selectedScrollSnap();
      const dots = dotsContainer?.querySelectorAll('.nf-text-slider__dot');
      dots?.forEach((dot, index) => {
        if (index === selectedIndex) {
          dot.classList.add('nf-text-slider__dot--active');
        } else {
          dot.classList.remove('nf-text-slider__dot--active');
        }
      });
    };

    const updateSlides = () => {
      const selectedIndex = embla.selectedScrollSnap();
      slides.forEach((slide, index) => {
        if (index === selectedIndex) {
          slide.classList.add('nf-text-slider__slide--active');
        } else {
          slide.classList.remove('nf-text-slider__slide--active');
        }
      });
    };

    const updateButtons = () => {
      if (prevButton) {
        prevButton.disabled = !embla.canScrollPrev();
      }
      if (nextButton) {
        nextButton.disabled = !embla.canScrollNext();
      }
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => embla.scrollPrev());
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => embla.scrollNext());
    }

    embla.on('select', () => {
      updateDots();
      updateButtons();
      updateSlides();
    });

    embla.on('init', () => {
      setupDots();
      updateDots();
      updateButtons();
      updateSlides();
    });

    setupDots();
    updateDots();
    updateButtons();
    updateSlides();

    // Setup autoplay
    const autoplay = carouselElement.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(carouselElement.dataset.autoplaySpeed) || 3;
    const autoplayIntervalMs = autoplaySpeed * 1000;

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      const interval = setInterval(() => {
        if (embla.canScrollNext()) {
          embla.scrollNext();
        } else {
          embla.scrollTo(0);
        }
      }, autoplayIntervalMs);
      autoplayIntervals.set(carouselElement, interval);
    }

    function stopAutoplay() {
      const interval = autoplayIntervals.get(carouselElement);
      if (interval) {
        clearInterval(interval);
        autoplayIntervals.delete(carouselElement);
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    if (autoplay) {
      startAutoplay();

      // Pause on hover
      carouselElement.addEventListener('mouseenter', stopAutoplay);
      carouselElement.addEventListener('mouseleave', startAutoplay);

      // Reset on user interaction
      embla.on('pointerDown', resetAutoplay);
      embla.on('select', resetAutoplay);
    }
  }

  function initAllCarousels() {
    const carousels = document.querySelectorAll('.nf-text-slider__viewport:not([data-initialized])');
    carousels.forEach((carousel) => {
      if (carousel instanceof HTMLElement) {
        carousel.setAttribute('data-initialized', 'true');
        initCarousel(carousel);
      }
    });
  }

  function handleThemeEditorUpdates() {
    // Listen for theme editor DOM updates
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', initAllCarousels);
      document.addEventListener('shopify:section:reorder', initAllCarousels);
      document.addEventListener('shopify:block:select', initAllCarousels);
    }
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllCarousels();
      handleThemeEditorUpdates();
    });
  } else {
    initAllCarousels();
    handleThemeEditorUpdates();
  }

  // Use MutationObserver for theme editor updates
  if (window.Shopify?.designMode) {
    const observer = new MutationObserver(() => {
      initAllCarousels();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

